import { useMutation, useQueryClient } from '@tanstack/react-query'
import { bulkUpdateLocationStatusByIds } from '../../../api/plan-location-override-rules-api'
import type { BulkUpdateLocationStatusByIdsRequestDto } from '../../../api/dto/plan-location-override-rules.dto'
import { LOCATION_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanLocationOverride/hooks/useGetLocationOverrideRules'

export function useBulkUpdateLocationStatusByIds() {
  const queryClient = useQueryClient()

  return useMutation<void, unknown, BulkUpdateLocationStatusByIdsRequestDto>({
    mutationFn: (body) => bulkUpdateLocationStatusByIds(body),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [LOCATION_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
